module.exports = __webpack_public_path__ + "img/Wp_2086.60a2047f.png";